import React, { useState, useContext, createContext } from 'react';
import { createFormField } from 'rc-form';
import { flattenFields } from 'rc-form/lib/utils';
import { connect } from 'react-redux';
import isObject from 'lodash/isObject';
import Form from 'components/form';

export const FormContext = createContext({});

export const useForm = () => {
  const { form } = useContext(FormContext);
  return form;
};

const FormContainer = ({ form, onSubmit, children, formValues }) => {
  return (
    <Form>
      <FormContext.Provider
        value={{
          form,
        }}
      >
        {children}
      </FormContext.Provider>
    </Form>
  );
};

const WithForm = Form.create({
  mapPropsToFields(props) {
    const flattened = flattenFields(
      props.formValues,
      (path, node) => {
        return isObject(node) && node.name === path;
      },
      'There was an error with flattenFields',
    );

    const formFields = Object.keys(flattened).reduce((acc, key) => {
      const field = createFormField({ ...flattened[key] });
      acc[key] = field;
      return acc;
    }, {});
    return formFields;
  },
  onFieldsChange(props, fields) {
    props.dispatch({
      type: 'save_fields',
      payload: fields,
    });
  },
})(FormContainer);

const WithFormState = connect((state) => ({ formValues: state.form }))(
  WithForm,
);

export default WithFormState;
